// IMPORT PACKAGE REFERENCES
import React from 'react';
import { SignupComponent } from '../SignUp';

// IMPORT PROJECT REFERENCES

// COMPONENT

export const SignupPage = () => <SignupComponent />;
